import React, { useState, useEffect } from 'react';
import { Button, App, Tooltip } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
//使用国际化
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/store/hooks';
import styles from './index.module.scss';
import icon1 from '@/assets/images/路径 1752.png';
import icon2 from '@/assets/images/组 2539.png';
import productImg from '@/assets/images/生成美国购物网页商品图 (15)@2x.png';

const OrderDetail: React.FC = () => {
  const { message } = App.useApp();
  //跳转
  const navigate = useNavigate();

  //国际化语言切换 AI不要删除
  const { t } = useTranslation();

  const params = useParams();

  // 模拟订单数据
  const [orderData, setOrderData] = useState({
    orderNumber: '12345678987654321',
    address: 'Jefferson Avenue,Anchorage,AK,123 Jefferson Avenue, Anchorage, AK 99517',
    name: 'Mike',
    phone: '147852369',
    estimatedShipping: '3 days',
    shop: 'Basket Bonanza',
    product: {
      name: 'Handmade Bamboo Basket: Woven with Bamboo Strips, Fine, Durable',
      classification: 'Shape Classification: Square Handheld Wicker Basket',
      price: 5.99,
      originalPrice: 6.99,
      quantity: 1,
    },
    payment: {
      totalProductPrice: 5.99,
      totalDiscount: 0,
      shippingFee: 0,
      actualPayment: 5.99,
    },
    paymentMethod: 'Bank of America payment',
    creationTime: 'June 30, 2025, 14:30:22',
    paymentTime: 'June 30, 2025, 14:50:22',
  });

  //mounted
  useEffect(() => {
    if (params.id) {
      console.log(params.id);
      // 这里可以根据id获取订单详情
    }
  }, []);

  // 修改地址
  const handleModifyAddress = () => {
    navigate('/yourtownloop/addresses');
  };

  // 申请退款
  const handleRefund = () => {
    message.info('申请退款功能将在后续版本中推出');
  };

  // 复制订单号
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderData.orderNumber)
      .then(() => {
        message.success('订单号已复制到剪贴板');
      })
      .catch(() => {
        message.error('复制失败，请手动复制');
      });
  };

  return (
    <div className={styles['order-detail']}>
      <h1 className={styles['page-title']}>Order Details</h1>

      <div className={styles['detail-container']}>
        <div className={styles['detail-section-box']}>
          {/* 订单状态和地址信息 */}
          <div className={styles['detail-section']}>
            <div className={styles['section-header']}>
              <div className={styles['section-title']}>Order paid</div>
            </div>

            <div className={styles['address-info']}>
              <div className={styles['address-icon']}>
                <img src={icon1} alt="Location" />
              </div>
              <div className={styles['address-content']}>
                <div className={styles['address-text']}>{orderData.address}</div>
                <div className={styles['contact-info']}>
                  {orderData.name} {orderData.phone}
                </div>
              </div>
            </div>

            <div className={styles['shipping-info']}>
              <div className={styles['shipping-icon']}>
                <img src={icon2} alt="Shipping" />
              </div>
              <div className={styles['shipping-text']}>
                Estimated to ship within {orderData.estimatedShipping}
              </div>
            </div>

            <Button
              type="primary"
              className={styles['modify-address-btn']}
              onClick={handleModifyAddress}
            >
              Modify address
            </Button>
          </div>

          {/* 订单信息和商品详情 */}
          <div className={`${styles['detail-section']} ${styles['detail-section2']}`}>
            <div className={styles['section-header']}>
              <h2 className={styles['section-title']}>Confirm order information</h2>
            </div>

            <div className={styles['shop-name']}>{orderData.shop}</div>

            <div className={styles['product-item']}>
              <div className={styles['product-image']}>
                <img src={productImg} alt={orderData.product.name} />
              </div>

              <div className={styles['product-info']}>
                <div className={styles['product-name']}>{orderData.product.name}</div>
                <div className={styles['product-classification']}>{orderData.product.classification}</div>
              </div>

              <div className={styles['product-price']}>
                <div className={styles['current-price']}>${orderData.product.price.toFixed(2)}</div>
                <div className={styles['original-price']}>${orderData.product.originalPrice.toFixed(2)}</div>
                <div className={styles['quantity']}>×{orderData.product.quantity}</div>
              </div>
            </div>

            <div className={styles['refund-action']}>
              <Button onClick={handleRefund} className={styles['refund-btn']}>Refund</Button>
            </div>
          </div>
        </div>


        {/* 右侧边栏 */}
        <div className={styles['sidebar']}>
          {/* 支付详情 */}
          <div className={styles['payment-section']}>
            <h2 className={styles['section-title']}>Payment details</h2>

            <div className={styles['payment-details']}>
              <div className={styles['payment-row']}>
                <span className={styles['payment-label']}>Total product price</span>
                <span className={styles['payment-value']}>${orderData.payment.totalProductPrice.toFixed(2)}</span>
              </div>

              <div className={styles['payment-row']}>
                <span className={styles['payment-label']}>Total discount</span>
                <span className={styles['payment-value']}>${orderData.payment.totalDiscount.toFixed(2)}</span>
              </div>

              <div className={styles['payment-row']}>
                <span className={styles['payment-label']}>Shipping fee</span>
                <span className={styles['payment-value']}>${orderData.payment.shippingFee.toFixed(2)}</span>
              </div>

              <div className={styles['payment-total']}>
                <span className={styles['payment-label']}>Actual payment</span>
                <span className={styles['payment-total-value']}>${orderData.payment.actualPayment.toFixed(2)}</span>
              </div>
            </div>
          </div>

          {/* 订单信息 */}
          <div className={styles['order-info-section']}>
            <h2 className={styles['section-title']}>Order information</h2>

            <div className={styles['order-info-details']}>
              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Order number</span>
                <div className={styles['info-value-with-action']}>
                  <span className={styles['info-value']}>{orderData.orderNumber}</span>
                  <span className={styles['copy-action']} onClick={handleCopyOrderNumber}>Copy</span>
                </div>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Payment method</span>
                <span className={styles['info-value']}>{orderData.paymentMethod}</span>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Creation time</span>
                <span className={styles['info-value']}>{orderData.creationTime}</span>
              </div>

              <div className={styles['info-row']}>
                <span className={styles['info-label']}>Payment time</span>
                <span className={styles['info-value']}>{orderData.paymentTime}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetail; 